<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-08-30 11:32:48
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-08-30 17:13:55
-->
<template>
  <div>
    <div class="search-box">
      <div style="margin: 0px 0 20px 10px; padding-top: 20px">
        <span class="title" @click="$router.push('/')">首页</span> >
        <span class="title">公共服务</span> >
        <span class="title">课程管理</span>
      </div>
      <div class="result-list" style="display: flex">
        <div class="result-menu-list" style="width:300px;">
          <a-menu>
            <a-sub-menu
              v-for="(item, index) in types"
              :key="`${item.key}-${index}`"
              @titleClick="({ key, domEvent }) => handleClickTag(key)"
            >
              <span slot="title"
                ><a-icon type="mail" /><span>{{ item.value }}</span></span
              >
            </a-sub-menu>
          </a-menu>
        </div>
        <div style="flex: 1; display: flex; flex-direction: column">
          <div
            class="result-item"
            v-for="(item, index) in list"
            :key="`${item.id}-${index}`"
            style="text-align:left;"
          >
            <div class="avatar">
              <img :src="item.cuirriculumPhoto" />
            </div>
            <div class="result-info">
              <div class="result-info-title">{{ item.name }}</div>
              <div class="result-info-left">
                <div class="result-info-content">
                  <span>{{
                    item.curriculumType == 0
                      ? '公开课'
                      : item.curriculumType == 1
                      ? '精品课'
                      : '认证课'
                  }}</span>
                </div>
                <div class="result-time">
                  <span>发布时间:{{ item.createTime }}</span>
                </div>
              </div>
              <div class="result-info-link">作者：{{ item.author }}</div>
              <div class="company">
                <!-- <div>企业名称:</div> -->
                <a
                  class="concat-btn"
                  href="javascript:;"
                  @click="handleke(item.id, item.curriculumType)"
                  >查看详情</a
                >
              </div>
            </div>
          </div>
          <div class="result-item">
            <pagination :num="num" :limit="limit" @getNew="getNew"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '../util/request'
import pagination from '../components/pagination.vue'
export default {
  name: 'productSystem',
  components: {
    pagination,
  },
  data() {
    return {
      pageIndex: 1,
      num: 0,
      limit: 10,
      data: new Array(5).fill({ title: '213' }),
      list: [],
      type: 0,
      types: [
        { key: 0, value: '公开课' },
        { key: 1, value: '精品课' },
        { key: 2, value: '认证课' },
      ],
    }
  },
  mounted() {
    this.queryList(0)
  },
  methods: {
    getNew(pageOffset) {
      this.pageIndex = pageOffset
      this.list = this.queryList(this.type)
    },
    handleke(id, curriculumType) {
      //验证是否登录
      this.$router.push({
        path: '/course_detail',
        query: { id: id, curriculumType: curriculumType },
      })
    },
    handleClickTag(item) {
      this.queryList(item)
    },
    queryList(type) {
      request({
        url: '/api/client/common/curriculum/list',
        method: 'get',
        params: {
          curriculumType: type,
          page: this.pageIndex,
          pageSize: this.limit,
        },
      }).then((res) => {
        if (res.code == '200') {
          this.list = res.data.records
          this.pageIndex = parseInt(res.data.current)
          this.num = parseInt(res.data.total)
          this.limit = parseInt(res.data.size)
        }
      })
    },
  },
}
</script>
<style lang="less">
.result-list {
  background: #fff;
  height: 100%;
  .result-menu-list {
    width: 260px;
    display: flex;
    flex-direction: column;
    .ant-menu-dark {
      height: 100%;
    }
    .ant-menu-item {
      width: 260px;
    }
    .menu-item {
      display: flex;
      align-items: center;
      height: 50px;
      cursor: pointer;
      padding: 10px;
    }
    .menu-item:hover {
      background-color: #e6f7ff;
      color: #1890ff;
    }
  }
  .result-item {
    padding: 20px;
    align-items: center;
    display: flex;
    height: 200px;
    border-bottom: 2px solid #f2f2f2;
    .avatar {
      width: 220px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .result-info {
      margin-left: 20px;
      width: 740px;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .result-info-left {
        display: flex;
        line-height: 35px;
      }
      .result-info-content {
        width: 75%;
        color: #000000a9;
      }
      .result-info-title {
        font-size: 18px;
        font-weight: bold;
      }

      .result-time {
        width: 35%;
      }
    }
    .company {
      padding-top: 0px;
      color: #333;
      .concat-btn {
        margin-left: 71%;
        border-radius: 8%;
        color: #fff;
        width: 160px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #0599fb;
        cursor: pointer;
      }
    }
  }
}
</style>
